export const baliGroupPackage = {
  id: "bali-7d6n",
  title: "Bali Group Tour",
  country: "Indonesia",
  days: 7,
  nights: 6,
  price: {
    adult: "₹99,500 per adult + 5% GST + 5% TCS",
    childWithBed: "₹85,000 per child (with bed) + 5% GST + 5% TCS",
    childNoBed: "₹77,500 per child (no bed) + 5% GST + 5% TCS",
  },

  thumbnail:
    "https://images.pexels.com/photos/2166559/pexels-photo-2166559.jpeg",

  description:
    "Explore the tropical paradise of Bali with pristine beaches, lush rice terraces, ancient temples, vibrant culture, and thrilling adventures. This 7-day guided tour ensures a perfect blend of sightseeing, relaxation, and cultural immersion.",

  highlights: [
    "Sunset at Tanah Lot Temple",
    "Ubud Monkey Forest & Rice Terraces",
    "Mount Batur Sunrise Trek",
    "Tegalalang Rice Terrace visit",
    "Waterbom Bali water park fun",
    "Balinese cultural performances",
    "Beach leisure time at Seminyak & Kuta",
  ],

  included: [
    "Return economy class airfare from Mumbai",
    "Visa charges as per itinerary",
    "Accommodation on twin sharing basis",
    "Meals as mentioned (Breakfast, Lunch & Dinner as per itinerary)",
    "Travel insurance up to 60 years of age",
    "All transfers & sightseeing in a coach",
    "All entrance fees for listed sightseeing",
    "Services of Tour Manager throughout the tour",
  ],

  excluded: [
    "5% GST & 5% TCS",
    "Increase in fuel surcharge or taxes",
    "Extension/deviation of tour route",
    "Porterage, laundry, shopping, telephone, personal expenses",
    "Alcoholic beverages & mineral water (unless specified)",
    "Extra expenses due to natural calamities or political disturbances",
    "Medical expenses due to illness/accident",
    "Private transfers (if taken instead of coach)",
    "Upgradation in airline class or hotel room category",
    "Anything not specifically mentioned in inclusions",
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival – Kuta / Seminyak",
      description:
        "Arrive in Bali. Meet your representative and transfer to hotel in Kuta/Seminyak. Relax at the beach or hotel. Overnight stay at Bali.",
      photo: "https://images.pexels.com/photos/14551162/pexels-photo-14551162.jpeg",
    },
    {
      day: 2,
      title: "Tanah Lot Temple & Beach Leisure",
      description:
        "After breakfast, visit Tanah Lot Temple, one of Bali's iconic sea temples. Enjoy sunset views. Evening free for beach leisure. Overnight stay at Bali.",
      photo: "https://images.pexels.com/photos/17299295/pexels-photo-17299295.jpeg",
    },
    {
      day: 3,
      title: "Ubud – Monkey Forest & Rice Terraces",
      description:
        "Full day excursion to Ubud. Visit Ubud Monkey Forest, Tegalalang Rice Terraces, and traditional markets. Experience Balinese culture. Overnight stay at Bali.",
      photo: "https://images.pexels.com/photos/2412711/pexels-photo-2412711.jpeg",
    },
    {
      day: 4,
      title: "Mount Batur Sunrise Trek",
      description:
        "Early morning Mount Batur sunrise trek. Witness spectacular sunrise views over the volcanic landscape. Return to hotel and relax. Optional spa treatments in the evening. Overnight stay at Bali.",
      photo: "https://images.pexels.com/photos/6367325/pexels-photo-6367325.jpeg",
    },
    {
      day: 5,
      title: "Waterbom Bali & Beach Leisure",
      description:
        "Enjoy a fun-filled day at Waterbom Bali, a world-famous water park. Afternoon free for beach activities or shopping. Overnight stay at Bali.",
      photo: "https://tse3.mm.bing.net/th/id/OIP.DusEJ2tWfMMtoEo6aFPUDwHaE6?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    },
    {
      day: 6,
      title: "Cultural Performance & Local Sightseeing",
      description:
        "Visit Uluwatu Temple and enjoy a Kecak Dance performance at sunset. Explore Jimbaran Bay for seafood dinner. Overnight stay at Bali.",
      photo: "https://images.pexels.com/photos/32162991/pexels-photo-32162991.jpeg",
    },
    {
      day: 7,
      title: "Departure from Bali",
      description:
        "After breakfast, check out from hotel and transfer to Bali airport for your onward flight. Tour ends with happy memories.",
      photo: "https://images.pexels.com/photos/2166643/pexels-photo-2166643.jpeg",
    },
  ],

  gallery: [
    "https://images.pexels.com/photos/14551162/pexels-photo-14551162.jpeg",
    "https://images.pexels.com/photos/17299295/pexels-photo-17299295.jpeg",
    "https://images.pexels.com/photos/2412711/pexels-photo-2412711.jpeg",
    "https://images.pexels.com/photos/6367325/pexels-photo-6367325.jpeg",
    "https://tse3.mm.bing.net/th/id/OIP.DusEJ2tWfMMtoEo6aFPUDwHaE6?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3",
    "https://images.pexels.com/photos/32162991/pexels-photo-32162991.jpeg",
    "https://images.pexels.com/photos/2166643/pexels-photo-2166643.jpeg",
    "https://images.pexels.com/photos/2166559/pexels-photo-2166559.jpeg",
    "https://images.pexels.com/photos/931007/pexels-photo-931007.jpeg",
    "https://images.pexels.com/photos/2166608/pexels-photo-2166608.jpeg",
    "https://images.pexels.com/photos/2186581/pexels-photo-2186581.jpeg"
  ],

  groupDates: [
    { group: "Group 1", start: "2025-11-10", end: "2025-11-16" },
    { group: "Group 2", start: "2025-12-05", end: "2025-12-11" },
    { group: "Group 3", start: "2026-01-15", end: "2026-01-21" },
    { group: "Group 4", start: "2026-02-20", end: "2026-02-26" },
  ],

  brochure:
    "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/packages%2Fbali_group_brochure.pdf?alt=media&token=example",

  rating: {
    stars: 4.8,
    reviews: 120,
  },

  reviews: [
    {
      stars: 5,
      review: "Bali was breathtaking! Beaches, culture, and adventure all in one trip.",
      name: "Amit Deshmukh",
    },
    {
      stars: 5,
      review: "Loved the Ubud rice terraces and the Mount Batur trek. Highly recommend!",
      name: "Sneha Kulkarni",
    },
    {
      stars: 4,
      review: "Good hotels and smooth transport. Food options could be better.",
      name: "Rohan Patil",
    },
  ],
};
